import React from 'react';
import PropTypes from 'prop-types';
import { useLabels, useRequestData } from 'wsm-common-data';
import { formatDate } from 'ddc-intl';
import { sanitizeContent } from '../utils/utils';
import { DealerResponse } from './DealerResponse';

export const getStars = (number) => {
	const rating = [];

	for (let i = 0; i < number; i++) {
		rating.push(
			<i
				key={i + 1}
				className="ddc-icon ddc-icon-star text-primary"
				aria-hidden="true"
			/>
		);
	}

	return rating;
};

export const Review = ({ dealerName, reviewData }) => {
	const { locale } = useRequestData();
	const {
		review: {
			_attributes: { date, stars },
			author: {
				_attributes: { city, first, last, state }
			},
			body: { _text: content },
			department: { _text: department },
			response: dealerResponse,
			vehicle: {
				_attributes: { make, model, year }
			}
		}
	} = reviewData;
	const locationInfo = city && state ? `${city}, ${state} | ` : '';
	const vehicleInfo = `${year} ${make} ${model}`;
	const customerInfo = `${locationInfo}${vehicleInfo}`;
	const labels = useLabels();

	return (
		<li className="rdc-review-item border-bottom py-4">
			<div className="rdc-review-heading pb-4">
				<div className="rdc-review-customer d-flex align-items-center">
					<h4 className="pr-3">
						{first} {last}
					</h4>
					<span className="text-muted small">{customerInfo}</span>
				</div>
				<div className="rdc-review-rating d-flex align-items-center small mb-3 text-muted">
					<div
						className="rdc-review-stars pr-3 ddc-font-size-large"
						aria-label={labels
							.get('X_STAR_RATING')
							.replace('{rating}', stars)}
					>
						{getStars(stars)}
					</div>
					<strong>
						{labels
							.get('CONFIRMED_DEPARTMENT_REVIEW')
							.replace('{department}', department)}
					</strong>
				</div>
				<div className="text-muted small">
					{formatDate(date, locale, {
						year: 'numeric',
						month: 'long',
						day: 'numeric'
					})}
				</div>
			</div>
			<div
				className="rdc-review-text pb-4"
				dangerouslySetInnerHTML={{
					__html: sanitizeContent(content)
				}}
			/>
			{dealerResponse !== null && dealerResponse?._text !== undefined && (
				<DealerResponse
					dealerName={dealerName}
					dealerResponseDate={formatDate(
						dealerResponse?._attributes?.date,
						locale,
						{ year: 'numeric', month: 'long', day: 'numeric' }
					)}
					dealerResponseText={dealerResponse?._text}
				/>
			)}
		</li>
	);
};

Review.propTypes = {
	dealerName: PropTypes.string.isRequired,
	reviewData: PropTypes.shape({
		review: PropTypes.shape({
			_attributes: PropTypes.shape({
				date: PropTypes.string.isRequired,
				stars: PropTypes.string.isRequired
			}).isRequired,
			author: PropTypes.shape({
				_attributes: PropTypes.shape({
					city: PropTypes.string,
					first: PropTypes.string.isRequired,
					last: PropTypes.string.isRequired,
					state: PropTypes.string
				})
			}).isRequired,
			body: PropTypes.shape({
				_text: PropTypes.string.isRequired
			}).isRequired,
			department: PropTypes.shape({
				_text: PropTypes.string.isRequired
			}).isRequired,
			response: PropTypes.shape({
				_attributes: PropTypes.shape({
					date: PropTypes.string.isRequired
				}).isRequired,
				_text: PropTypes.string.isRequired
			}).isRequired,
			vehicle: PropTypes.shape({
				_attributes: PropTypes.shape({
					make: PropTypes.string.isRequired,
					model: PropTypes.string.isRequired,
					year: PropTypes.string.isRequired
				}).isRequired
			}).isRequired
		}).isRequired
	}).isRequired
};
